import Jt from 'common/util/jt';
import {inApp, appName, appSlogan, appLogo} from 'common/constant';
import * as api from 'common/service/server-api';

class WxShare {
    constructor() {
        this.timer = null;
        if(!inApp) {
            this.init();
        }
    }

    init() {
        this.defaults = {
            title: appName,
            desc: appSlogan,
            imgUrl: appLogo
        };
        Jt.loader.loadScripts(['https://res.wx.qq.com/open/js/jweixin-1.2.0.js'], () => {
            this.getSdk();
        });
    }

    getSdk() {
        api.getWxSdk({}, function (data = {}) {
            wx.config({
                debug: false,
                /**必填，公众号唯一标识 */
                appId: data.appId,
                /**必填，生成签名的时间戳*/
                timestamp: data.timestamp,
                /**必填，生成签名的随机串*/
                nonceStr: data.nonceStr,
                /**必填，签名*/
                signature: data.signature,
                /**必填，需要使用的JS接口列表*/
                jsApiList: [
                    "onMenuShareTimeline",
                    "onMenuShareAppMessage",
                    "onMenuShareQQ",
                    "onMenuShareQZone",
                    "onMenuShareWeibo"
                ]
            });
        });
    }

    setData(data = {}) {
        if(window.wx) {
            const defaults = this.defaults;
            const shareData = {
                title: data.title ? data.title : defaults.title,
                desc: data.desc ? data.desc : defaults.desc,
                imgUrl: data.imgUrl ? data.imgUrl : defaults.imgUrl,
                link: window.location.href
            };
            wx.ready(function() {
                wx.onMenuShareTimeline(shareData);
                wx.onMenuShareAppMessage(shareData);
                wx.onMenuShareQQ(shareData);
                wx.onMenuShareWeibo(shareData);
                wx.onMenuShareQZone(shareData);
            });
        } else {
            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.setData(data);
            }, 200);
        }
    }
}

export default new WxShare();



// WEBPACK FOOTER //
// ./src/common/service/wx-share.js